import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {getDate, Message} from '../../../_metronic/helpers'
import {
  addHoliday,
  deleteHolidays,
  getHolidays,
  getHolidaysById,
  updateHolidayById,
} from '../../../api/HolidayAPI'
import {DELETE_MESSAGE, UPDATE_MESSAGE} from '../../../utils/contants'
import {AlertProps} from '../../data/AlertDefaults'
//Auto Holiday Fetch
import Holidays from "date-holidays";
import { setupAxios } from '../../modules/auth'
import { api } from '../../../api/APIMiddlewares'

export const getHoliday = (setHoliday: Function, setAPIStatus: Function) => {
  setAPIStatus((prev: any) => ({...prev, loading: true}))
  getHolidays().then((res: any) => {
    if (res.statusCode === 200) {
      const holidaysWithIndex = res.data.map((holiday: any, index: number) => ({
        ...holiday,
        index: index + 1,
      }))

      setHoliday(res.data)

      setAPIStatus((prev: any) => ({...prev, loading: false, error: null}))
    } else {
      setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
    }
  })
}

// form save function

export const handleSubmit = (
  InputField: {
    holidayName: string
    date: string
    isFloating: boolean
  },
  getHoliday: Function,
  setHoliday: Function,
  setEditId: Function,
  initialState: {
    holidayName: string
    date: string
    isFloating: boolean
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  setIsAddUserModalOpen: Function
) => {
  let {cnt, error} = validateForm(InputField)
  setInputError(error)

  if (cnt === 0) {
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
      addHoliday(InputField).then((res) => {
        if (res.statusCode === 201) {
          toast.success(res.message)
          getHoliday(setHoliday, setAPIStatus)
          cancelSubmit(setInputField, initialState, setEditId, setInputError)
          setIsAddUserModalOpen(false)
        } else {
          Message(res.message, 'error')
        }
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      })
    } else {
      Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then((result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
          updateHolidayById(InputField, editId).then((res: any) => {
            if (res.statusCode === 200) {
              getHoliday(setHoliday, setAPIStatus)
              toast.success(res.message)
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              setEditId(null)
              setIsAddUserModalOpen(false)
            } else {
              Message(res.message, 'error')
            }
            setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
          })
        }
      })
    }
  }
}

// delete holiday

export const deleteHoliday = (
  id: string,
  getHoliday: Function,
  setHoliday: Function,
  setAPIStatus: Function,
  cancelSubmit: Function,
  setInputField: Function,
  InputField: {
    holidayName: string
    date: string
    isFloating:boolean
  },
  setEditId: Function,

  setInputError: Function
) => {
  cancelSubmit(setInputField, InputField, setEditId, setInputError)
  Swal.fire({...AlertProps, icon: 'warning', title: DELETE_MESSAGE}).then((result: any) => {
    if (result.isConfirmed) {
      deleteHolidays(id)
        .then((res: any) => {
          if (res.statusCode === 202) {
            getHoliday(setHoliday, setAPIStatus)
            toast.success(res.message)
          } else {
            Message(res.message, 'error')
          }
        })
        .catch((res: any) => {
          Message(res.message, 'error')
        })
    }
  })
}

//getHolidayByID

export const getHolidayById = (
  id: string,
  InputField: {
    holidayName: string
    date: string
    isFloating:boolean
  },
  setInputField: Function,
  setEditId: Function,
  setInputError: Function
) => {
  getHolidaysById(id).then((res: any) => {
    if (res.statusCode === 200) {
      let {formattedDate} = getDate(res.data.date)
      setInputField({
        ...InputField,
        holidayName: res.data.name,
        date: formattedDate,
        isFloating: res.data.isFloating ?? false,
      })
      setEditId(id)
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error') // Assuming the Message function is imported from the correct location
    }
  })
}
export const validateForm = (InputField: {holidayName: string; date: string; isFloating:boolean}) => {
  let cnt = 0
  const error: any = {}

  const minHolidayNameLength = 2
  const maxHolidayNameLength = 35
  const holidayName = InputField.holidayName.trim()

  if (!holidayName) {
    cnt = cnt + 1
    error.holidayName = 'Please enter a Holiday Name.'
  } else if (holidayName.length < minHolidayNameLength) {
    cnt = cnt + 1
    error.holidayName = 'Holiday Name must be at least 2 characters.'
  } else if (holidayName.length > maxHolidayNameLength) {
    cnt = cnt + 1
    error.holidayName = 'Holiday Name must not exceed 35 characters.'
  } else if (!/^[a-zA-Z ]+$/.test(holidayName)) {
    cnt = cnt + 1
    error.holidayName = 'Please enter a valid Holiday Name using only alphabetic characters.'
  }

  if (!InputField.date.trim()) {
    cnt = cnt + 1
    error.date = 'Please select/enter a valid Date.'
  }
  return {error, cnt}
}
export const cancelSubmit = (
  setInputField: Function,
  InputField: {holidayName: string; date: string; isFloating: boolean},
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}
//Replace stored year with current year
// export const getHolidayDate = (holiday: any) => {
//   const currentYear = new Date().getFullYear()

//   if (!holiday?.date) return null

//   const d = new Date(holiday.date)

//   // automatically update year
//   d.setFullYear(currentYear)

//   return d
// }

//---------------Diwali & Holi Dynamically Added----------------
// export const getHolidayDate = (holiday: any) => {
//   const currentYear = new Date().getFullYear()
//   if (!holiday?.date) return null
//   // dynamic holiday mapping
//   const dynamicHolidays: any = {
//     Holi: {
//       2026: '2026-03-03',
//     },
//     Diwali: {
//       2026: '2026-11-08',
//     },
//   }
//   // check dynamic holiday
//   if (dynamicHolidays[holiday.name]?.[currentYear]) {
//     return new Date(dynamicHolidays[holiday.name][currentYear])
//   }
//   // default fixed holiday
//   const d = new Date(holiday.date)
//   d.setFullYear(currentYear)
//   return d
// }
//---------------Diwali & Holi Auto Fetch Added----------------
export const getHolidayDate = (holiday: any) => {
  
  const currentYear = new Date().getFullYear()
  if (!holiday?.date) return null
  const hd = new Holidays("IN")
  const holidays = hd.getHolidays(currentYear)
  const holidayName = holiday.name.toLowerCase()
  console.log("Library Holidays:", holidays)

  // explicitly match dynamic holidays
  //  Add manual dynamic festivals
  const dynamicFestivalDates: any = {
    holi: {
      2026: "2026-03-03",
      2027: "2027-03-22",
      2028: "2028-03-11"
    },
    diwali: {
      2026: "2026-11-08",
      2027: "2027-10-29",
      2028: "2028-10-17"
    }
  }
  if (dynamicFestivalDates[holidayName]?.[currentYear]) {
    return new Date(dynamicFestivalDates[holidayName][currentYear])
  }
  const dynamicHoliday = holidays.find((h: any) =>
    ["holi", "diwali", "deepavali", "good friday"].some(name =>
      h.name.toLowerCase().includes(name) &&
      holidayName.includes(name)
    )
  )
  if (dynamicHoliday) {
    return new Date(dynamicHoliday.date)
  }
  // fallback for fixed holidays
  const d = new Date(holiday.date)
  d.setFullYear(currentYear)
  return d
}

export async function getMyFloatingHolidays() {
  const {token, tenantId} = setupAxios()
  return await api
    .get(
      `/floating-leave/my-floating-holidays`,
      token,
      tenantId,
      false
    )
    .then((res) => res)
}

